
import './DonneesCv.scss';

import React from 'react';

import {Svg1Step22 } from '../../../data/SVGs';
import useWindowSize from '../../../hooks/useWindowSize';
import DonneeCvPartage from '../../Admin/GestionExpert/DonneeCvPartage';
import { typeTraitementEnum } from './DonneesPersonnelsExpert';
import DrawSideBar from './SideBar';
import SideBarMobile from './SideBarMobile';
// * Styles Objects

const ExpertStep2_2 = () => {
    const {device}=useWindowSize();
    return (
        <>
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch'}}>
                {device=='desktop' &&
                <DrawSideBar />
                }
                {device!='desktop' &&
                    <SideBarMobile
                        etape={'Données CV'}
                        etapSuivante='Préférence'
                        number='2'
                    />
                }
                <div style={{display:'flex',width:device=='desktop'?'80%':'100%',justifyContent:'center',paddingBottom:'24px' ,paddingLeft:device=='desktop'?'0px':'16px',paddingRight:device=='desktop'?'0px':'16px',paddingTop: device=='desktop'?'64px':'16px',}}>
                    <DonneeCvPartage typeTraitement={typeTraitementEnum.EXPERT_COMPLETE_PROFILE}/>
                </div>
                {device=='desktop' &&
                <div style={{display:'flex',justifyContent:'flex-end',alignItems: 'center',position:'fixed',right:'0'}}>
                    <Svg1Step22 />
                </div>
                }
            </div>
        </>
    );
};

export default ExpertStep2_2;

{/*  <motion.div
            className="col-md-6 offset-md-3 StepDiv"
            initial={{ x: '-100vw' }}
            animate={{ x: 0 }}
            transition={{ stiffness: 150 }}
            style={{
                width: ' 100% !important',
                marginLeft: '0 % !important',
            }}
        >*/}
{/*  </motion.div>*/}